import {Component, OnInit} from '@angular/core';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive
} from '@angular/router';
import {NgClass, NgIf, NgOptimizedImage} from '@angular/common';
import {VersionService} from '../../../services/version/version.service';
import {AuthService} from '../../../services/auth/auth.service';
import {User} from '../../../models/user';
import {ImageService} from '../../../services/image/image.service';

@Component({
  selector: 'app-left-navbar',
  imports: [
    RouterLink,
    RouterLinkActive,
    NgClass,
    NgIf,
    NgOptimizedImage
  ],
  templateUrl: './left-navbar.component.html',
  styleUrl: './left-navbar.component.scss'
})
export class LeftNavbarComponent implements OnInit {

  private url: string | null = null;
  protected accountManager: User | null = null;

  constructor(
    private router: Router,
    private versionService: VersionService,
    private auth: AuthService,
    protected imageService: ImageService
  ) {
    this.auth.getConfig()
  }

  getActiveMenuClass(route: string): string {
    return this.url?.startsWith(route) ? 'active' : '';
  }

  ngOnInit(): void {
    this.router.events.subscribe((data) => {
      if (data instanceof NavigationEnd) {
        this.url = data.url;
      }
    });

    this.auth.getAsyncConfig().subscribe((config) => {
      if (config) {
        this.accountManager = config.partner?.accountManager ?? null;
      }
    });
  }

  getVersion(): string {
    return this.versionService.getFullVersion();
  }

  getEmail(): string {
    return 'mailto:' + this.accountManager?.email;
  }

  getTelegram(): string | null {
    return this.accountManager?.telegram ? 'https://t.me/' + this.accountManager?.telegram : null;
  }

  getTeams(): string | null {
    return this.accountManager?.teams ? 'https://teams.microsoft.com/l/chat/0/0?users=' + encodeURIComponent(this.accountManager?.teams ?? '') : null;
  }
}
